import { createSlice } from '@reduxjs/toolkit';

const loginSlice = createSlice({
  name: 'login',
  initialState: {
    isAuthenticated: false,
  },
  reducers: {
    login(state) {
      state.isAuthenticated = true;
    },
    logout(state) {
      state.isAuthenticated = false;
    },
    checkAuth(state) {
        const token = localStorage.getItem('access_token');
        state.isAuthenticated = !!token;
      }
  },
});

export const { login, logout,checkAuth } = loginSlice.actions;
export default loginSlice.reducer;